import React from 'react';
import { arrayOf, string, func, bool, object, oneOfType } from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import { useSession } from 'hooks';
import RouteComponent from 'components/routes/RouteComponent';
import { routesPaths } from 'constants/routesPaths';

const previewBypass = process.env.PREVIEW_BYPASS_AUTH === 'true';

const RoleGatedRoute = ({ allowedRoles, ...route }) => {
  const { authenticated, user } = useSession();

  if (previewBypass) {
    return <RouteComponent {...route} />;
  }

  if (!authenticated) {
    return (
      <Route
        render={props => (
          <Redirect
            to={{
              pathname: routesPaths.login,
              state: { from: props.location }
            }}
          />
        )}
      />
    );
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(user.type)) {
    return <Route render={() => <Redirect to={routesPaths.home} />} />;
  }

  return <RouteComponent {...route} />;
};

RoleGatedRoute.propTypes = {
  allowedRoles: arrayOf(string).isRequired,
  component: oneOfType([func, object]).isRequired,
  path: string.isRequired,
  exact: bool,
  layout: bool
};

export default RoleGatedRoute;
